import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingSkuDependency } from './types';

export function useBillingSkuDependencies(skuId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<TBillingSkuDependency[]>(
    skuId ? `commenda-billing/catalog/skus/${skuId}/dependencies` : null,
    SWRFetcher({ method: 'GET' })
  );

  return { dependencies: data ?? [], error, isLoading, mutate };
}
